export enum Faxstatus {
  AKTIV,
  INAKTIV,
}
